import { useEffect } from 'preact/hooks';

export const useWindowEvent = <K extends keyof WindowEventMap>(
  type: K,
  listener: (this: Window, ev: WindowEventMap[K]) => any
) => {
  useEffect(() => {
    window.addEventListener(type, listener);

    return () => window.removeEventListener(type, listener);
  }, [type, listener]);
};
